import { motion } from 'framer-motion';
import { PageTransition, FadeIn } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';
import { StaticCard, TrainingReferenceLink } from '../components/BorderCard';

const CRMPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what" label="Back" />

      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Module
          </h2>
          <h1 className="text-3xl md:text-4xl font-light tracking-tight text-[#1A1A1A] mb-4">
            CRM – Customer Relationship Management
          </h1>
          <TrainingReferenceLink 
            href="https://www.canva.com/design/DAHEezcpbcM/zJda--pm5tZTdI0a0Y_KtQ/view?utm_content=DAHEezcpbcM&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h60b442fd32"
          />
        </motion.div>

        {/* Objective */}
        <FadeIn delay={0.3}>
          <StaticCard className="p-10 text-center">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1A1A1A]/60 mb-6">
              Objective
            </h3>
            <p className="text-base font-light leading-relaxed text-[#1A1A1A]/80 mb-4">
              CRM focuses on building long-term customer relationships through personalized experiences and consistent engagement.
            </p>
            <p className="text-base font-light leading-relaxed text-[#1A1A1A]/80">
              It helps drive customer loyalty, repeat purchases, and a seamless brand experience.
            </p>
            <div className="text-[9px] uppercase tracking-wider text-[#1A1A1A]/30 mt-6">
              For reference only
            </div>
          </StaticCard>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default CRMPage;
